.fix-switch-thumb-vertical-positioning-on-web > * {
  align-self: center !important;
}
